import axios from "axios";
import { getToken, getTokenMicro } from "../../config/getToken";
import { env } from "../../env";

//TODO: ajustar el objeto data con los nuevos atributos donde se haga el llamado a GetCatalogues, el axios ya esta ajustado
/** Obtiene el listado de catálogos cargados de una compañía.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de catálogos. */
export async function GetCatalogues(data) {
  const token = await getToken();
  const tokenMicro = await getTokenMicro();

  return axios({
    method: "POST",
    data: data,
    url: `masters/uploads/companies`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
      "X-Authorization": tokenMicro,
    },
  });
}

/** Obtiene la plantilla de catálogo de productos.
 * @returns {Promise<*>} Plantilla codificada. */
export async function GetCataloguesTemplate() {
  const token = await getToken();
  return axios({
    method: "GET",
    url: `products/downloads/templates`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene la guía de catálogo de productos.
 * @returns {Promise<*>} Guía codificada. */
export async function GetCataloguesGuide() {
  const token = await getToken();
  return axios({
    method: "GET",
    url: `products/downloads/guides`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Descarga un archivo de catálogo.
 * @param {Object} data - Datos de descarga.
 * @returns {Promise<*>} Archivo descargado. */
export async function DownloadCatalogueFile(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: `masters/downloads`,
    baseURL: env.REACT_APP_API_URL,
    data: data,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Descarga el log de errores de catálogo.
 * @param {Object} data - Datos del log a descargar.
 * @returns {Promise<*>} Log de errores. */
export async function DownloadCatalogErrorLog(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: `masters/downloads/logs`,
    baseURL: env.REACT_APP_API_URL,
    data: data,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene la vista previa del catálogo de una compañía.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Vista previa del catálogo. */
export async function GetPreviewCatalog(data) {
  const { eanCompany } = data;
  const token = await getToken();
  return axios({
    method: "GET",
    url: `products/companies/${eanCompany}`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    data: data,
    headers: {
      Authorization: token,
    },
  });
}
//TODO: Ajustar el objeto GenerateDownloadCatalogueRequest por integracion de grupo empresarial (yo lo ajuste creo q esta bien)
/** Genera una solicitud de descarga de catálogo.
 * @param {Object} data - Datos de la solicitud.
 * @returns {Promise<*>} Respuesta de la solicitud. */
export async function GenerateDownloadCatalogueRequest(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    timeout: 1000 * 90,
    url: `products/downloads`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    data: data,
    headers: {
      Authorization: token,
    },
  });
}
/** Lista los catálogos descargados de una compañía.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de descargas. */
export async function ListDownloadCatalogue(data) {
  const token = await getToken();
  const tokenMicro = await getTokenMicro();

  return axios({
    method: "POST",
    data: data,
    url: `masters/downloads/companies`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
      "X-Authorization": tokenMicro,
    },
  });
}

/** Descarga un archivo de catálogo desde la sección de descargas.
 * @param {Object} data - Datos de descarga.
 * @returns {Promise<*>} Archivo descargado. */
export async function DownloadCatalogueOnDownload(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: `masters/downloads`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    data: data,
    headers: {
      Authorization: token,
    },
  });
}